import { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { TextField, FormGroup, FormControlLabel, Checkbox, Box, IconButton, Radio, Typography, Breadcrumbs, FormControl, FormLabel, RadioGroup, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import DeleteIcon from "@mui/icons-material/Delete";
import { useState } from 'react';
import Upload from '../upload/Upload';
import { UploadFile } from '@mui/icons-material';


const style = {
    border: '1px solid #ccc',
    borderRadius: '8px',
    padding: '0.75rem 1rem',
    marginBottom: '0.5rem',
    backgroundColor: 'white',
    cursor: 'grab',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
    transition: 'box-shadow 0.2s ease-in-out, transform 0.1s ease-in-out',
};
const CardDrag = ({ id, type, index, properties, moveCard, updateIndex, onClick, onDelete }) => {
    const [isHovered, setIsHovered] = useState(false);

    const ref = useRef(null)
    const [{ handlerId }, drop] = useDrop({
        accept: 'card',
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(item, monitor) {
            if (item.id === -1) {
                updateIndex(index)
                return;
            }
            if (!ref.current) {
                return
            }
            const dragIndex = item.index
            const hoverIndex = index
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }
            // Determine rectangle on screen
            const hoverBoundingRect = ref.current?.getBoundingClientRect()
            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
            // Determine mouse position
            const clientOffset = monitor.getClientOffset()
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return
            }

            if (item.id === -1) {
                //   addCard(item);
            } else {
                // Time to actually perform the action
                moveCard(dragIndex, hoverIndex)
            }
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex
        },
    })
    const [{ isDragging }, drag] = useDrag({
        type: 'card',
        item: () => {
            return { id, index }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    })
    const opacity = isDragging ? 0 : 1
    drag(drop(ref))

    function getPropertiItem(key) {
        var item = properties ? properties.find(p => p.name === key) : null;
        if (item) return item.value;
        return 'Valor';
    }
    function montaType(type) {
        console.log('>>>montaType<<<', type )
        if (type === 'camposUserLogado') {
            return (
                <Typography>Campos somente leitura - user logado - </Typography>
            )
        }
        if (type === 'selectField') {
            const itens = getPropertiItem('itens');
            console.log( typeof itens);
            const tp = typeof itens;
            return (
                <FormControl fullWidth>
                    <InputLabel id={getPropertiItem('id')+"-label"}>{getPropertiItem('label')}</InputLabel>
                    <Select
                        labelId={getPropertiItem('id')+"-label"}
                        id={getPropertiItem('id')}
                        label={getPropertiItem('label')}
                    >
                        {tp === 'object' && itens && itens.map((o) => (
                            <MenuItem key={o.id} value={o.label}>{o.label}</MenuItem>
                        ))}
                        
                    </Select>
                    <FormHelperText>{getPropertiItem('helper')}</FormHelperText>
                </FormControl>
            )
        }

        if (type === 'breadcrumbs') {
            return (
                <Breadcrumbs
                    id={getPropertiItem("id")}
                    crumbs={[
                        {
                            isHome: true,
                            label: "Home",
                        },
                        {
                            label: getPropertiItem("label"),
                            // href: "#", // Se não quiser que seja clicável, remova esta linha
                            active: true,
                        }
                    ]}
                />

            )
        }
        if (type === 'textField') {
            return (
                <TextField
                    style={{ maxWidth: '100%' }}
                    id={getPropertiItem('id')}
                    label={getPropertiItem('label')}
                    variant="outlined"
                    defaultValue={getPropertiItem('placeholder')}
                    size="small"
                    slotProps={{
                        input: { readOnly: true },
                    }}
                />

            )
        }
        if (type === 'textFieldMoeda') {
            return (
                <TextField
                    style={{ maxWidth: '100%' }}
                    id={getPropertiItem('id')}
                    label={getPropertiItem('label')}
                    variant="outlined"
                    size="small"
                    slotProps={{
                        input: { readOnly: true },
                    }}
                />
            )
        }
        if (type === 'checkBox') {
            return (
                <FormGroup>
                      <FormControlLabel control={<Checkbox defaultChecked />} label={getPropertiItem('label')} />
                </FormGroup>
            )
        }
        if (type === 'radio') {
            return (
                <FormGroup>
                    <FormControlLabel control={<Radio defaultChecked />} label={getPropertiItem('label')} />
                </FormGroup>
            )
        }
        if (type === 'radioGroup') {
            const opt = getPropertiItem('options');
            return (
                <FormControl>
                    <FormLabel>{getPropertiItem('label')}</FormLabel>
                    <RadioGroup
                        name={"radio-buttons-group-" + getPropertiItem('id')}
                    >
                        {opt && opt.map((o) => (
                            <FormControlLabel key={o.id} value={o.label} control={<Radio />} label={o.label} />
                        ))}
                    </RadioGroup>
                </FormControl>
            )
        }
        if (type === 'dataField') {
            return (
                <TextField id={getPropertiItem('id')} label={getPropertiItem('label')} variant="outlined"
                    defaultValue={"dia/mes/ano"} size="small"
                    slotProps={{
                        input: {
                            readOnly: true,
                        },
                    }}
                />
            )
        }
        if (type === 'textArea') {
            return (
                <TextField id={getPropertiItem('id')} label={getPropertiItem('label')} variant="outlined" multiline maxRows={2}
                    // size="small"
                    slotProps={{
                        input: {
                            readOnly: true,
                        },
                    }}
                />
            )
        }

        if (type === 'upload') {
            return (
                <Typography>Upload de arquivos</Typography>
            )
        }
        if (type === 'uploadUnico') {
            return (
                <Typography>Upload Unico</Typography>
            )
        }

        return (
            <Box
                sx={{
                    minWidth: 300,
                    height: 35
                }}
            />
        )
    }
    function handleOnClick() {
        if (onClick) onClick(type, index)
    }

    function handleDelete(e) {
        e.stopPropagation();
        if (onDelete) onDelete(index);
    }

    return (
        <div
            ref={ref}
            style={{
                ...style,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
            }}
            data-handler-id={handlerId}
            onClick={handleOnClick}
        >
            {montaType(type)}
            <IconButton onClick={handleDelete} size="small">
                <DeleteIcon />
            </IconButton>
        </div>



    )
}

export default CardDrag;